import { createBrowserRouter } from 'react-router-dom';
import { isAdminSubdomain } from '@/utils/extractProjectSlug';
import { PUBLIC_APEX } from '@/config/public-host';
import { isCustomDomain } from '@/utils/publicHost';
import { authRoutes } from './sections/auth';
import { LEGAL_ROUTES } from './sections/legal';
import { KIT_ROUTES } from './sections/kit';
import { CABINET_ROOT_ELEMENT, PROJECT_ROUTES } from './sections/project';
import { ORG_ROUTES } from './sections/org';
import { ADMIN_LEGACY_ROUTES, ADMIN_PANEL_CHILDREN, ADMIN_ROOT_ELEMENT } from './sections/admin';
import { CUSTOM_DOMAIN_ROUTES, PUBLIC_ROUTES } from './sections/public';

// WEB-3956 юнит 8: таблица маршрутов кабинета разложена по разделам
// (`router/sections/*.tsx`, обёртки ожидания — `router/suspense.tsx`); этот
// файл только собирает два роутера. Новый экран — ленивая страница и маршрут
// в файле своего раздела, тест — рядом с ним; новый раздел — строкой здесь
// (сторож полноты — `sections/catalog.test.ts`, там же снимок всего дерева).

// WEB-471: the reserved `admin.<apex>` subdomain is DEDICATED to the /admin
// panel. On that host EVERY dashboard route redirects to /admin (see the "/"
// route below), so the regular tenant app is not reachable there; on any other
// host the app behaves normally. Computed once at module load — the host does
// not change during a session.
const IS_ADMIN_HOST = isAdminSubdomain(window.location.hostname, PUBLIC_APEX);

const customDomainRouter = createBrowserRouter(CUSTOM_DOMAIN_ROUTES);

const apexRouter = createBrowserRouter([
  ...authRoutes(IS_ADMIN_HOST),
  ...LEGAL_ROUTES,
  // WEB-640 (FULLSWEEP §0): dev-only витрины. `import.meta.env.PROD` Vite
  // подставляет статически в сборку → в проде ветка вырезается и маршруты
  // исчезают из таблицы. (Роутер импортит только App.tsx, ts-jest его не компилит.)
  ...(!import.meta.env.PROD ? KIT_ROUTES : []),
  // Protected dashboard routes
  {
    path: '/',
    // admin.<apex>: the panel is mounted directly at the domain root (its URLs
    // are /health/*, /manage/* — no /admin prefix). AdminRoute gates it.
    element: IS_ADMIN_HOST ? ADMIN_ROOT_ELEMENT : CABINET_ROOT_ELEMENT,
    children: IS_ADMIN_HOST ? ADMIN_PANEL_CHILDREN : [...PROJECT_ROUTES, ...ORG_ROUTES],
  },
  ...ADMIN_LEGACY_ROUTES,
  ...PUBLIC_ROUTES,
]);

export const router = isCustomDomain() ? customDomainRouter : apexRouter;
